export default {
    shared: {
        topLevel: 'Top level',
        noText: '(no text)',
        invalid: 'Invalid',
    },
    list: {
        title: 'Menus',
        add: 'Add entry',
        savingOrder: 'Saving order…',
        noMenus: "The active theme doesn't call {fn} anywhere, so there are no menus to manage. Add a {loop} loop to your theme templates, redeploy, then reload this page.",
        help: "Drag a row by its handle. Drop on the {edges} of another row to reorder, or on its {middle} to nest it as a child. Navigation text falls back to the linked page's title unless overridden.",
        helpEdges: 'top/bottom edge',
        helpMiddle: 'middle',
        pageTitle: 'page title',
        pageTitleHint: "Uses the linked page's title",
        nestedUnder: 'Nested under {parent}',
        childOf: 'child of {parent}',
        pageRef: 'page #{id}',
        confirmRemove: 'Remove "{name}" from this menu?',
        empty: 'No entries yet for this menu and locale.',
        addOne: 'Add one',
    },
    edit: {
        editTitle: 'Edit menu entry',
        newTitle: 'New menu entry',
        menu: 'Menu',
        locale: 'Locale',
        page: 'Linked page',
        pageHint: 'Leave empty for a free-form anchor or external link.',
        pageHome: '{title} (home)',
        label: 'Navigation text',
        labelExample: 'Contact',
        labelHintPage: 'Empty = use the page title.',
        labelHintFree: 'Required for free-form entries.',
        href: 'Href',
        hrefPlaceholder: '#contact or /about#team or https://example.com',
        hrefHint: 'In-page anchor, relative URL with #anchor, or absolute URL.',
        parent: 'Parent menu entry',
        parentHint: 'Nest this entry under another menu entry, or keep it at the top level.',
        newTab: 'Open in a new tab',
        newTabHint: 'For a PDF or any link that should not replace the site.',
    },
};
